!(function (t, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e(require("@popperjs/core")))
    : "function" == typeof define && define.amd
    ? define(["@popperjs/core"], e)
    : ((t =
        "undefined" != typeof globalThis ? globalThis : t || self).bootstrap =
        e(t.Popper));
})(this, function (t) {
  "use strict";
  function e(t) {
    if (t && t.__esModule) return t;
    var e = Object.create(null);
    return (
      t &&
        Object.keys(t).forEach(function (i) {
          if ("default" !== i) {
            var s = Object.getOwnPropertyDescriptor(t, i);
            Object.defineProperty(
              e,
              i,
              s.get
                ? s
                : {
                    enumerable: !0,
                    get: function () {
                      return t[i];
                    },
                  }
            );
          }
        }),
      (e.default = t),
      Object.freeze(e)
    );
  }
  var i = e(t);
  const s = {
      find: (t, e = document.documentElement) =>
        [].concat(...Element.prototype.querySelectorAll.call(e, t)),
      findOne: (t, e = document.documentElement) =>
        Element.prototype.querySelector.call(e, t),
      children: (t, e) => [].concat(...t.children).filter((t) => t.matches(e)),
      parents(t, e) {
        const i = [];
        let s = t.parentNode;
        for (; s && s.nodeType === Node.ELEMENT_NODE && 3 !== s.nodeType; )
          s.matches(e) && i.push(s), (s = s.parentNode);
        return i;
      },
      prev(t, e) {
        let i = t.previousElementSibling;
        for (; i; ) {
          if (i.matches(e)) return [i];
          i = i.previousElementSibling;
        }
        return [];
      },
      next(t, e) {
        let i = t.nextElementSibling;
        for (; i; ) {
          if (i.matches(e)) return [i];
          i = i.nextElementSibling;
        }
        return [];
      },
    },
    n = "transitionend",
    o = (t) => {
      do {
        t += Math.floor(1e6 * Math.random());
      } while (document.getElementById(t));
      return t;
    },
    r = (t) => {
      let e = t.getAttribute("data-bs-target");
      if (!e || "#" === e) {
        let i = t.getAttribute("href");
        if (!i || (!i.includes("#") && !i.startsWith("."))) return null;
        i.includes("#") && !i.startsWith("#") && (i = `#${i.split("#")[1]}`),
          (e = i && "#" !== i ? i.trim() : null);
      }
      return e;
    },
    a = (t) => {
      const e = r(t);
      return e && document.querySelector(e) ? e : null;
    },
    l = (t) => {
      const e = r(t);
      return e ? document.querySelector(e) : null;
    },
    c = (t) => {
      t.dispatchEvent(new Event(n));
    },
    h = (t) =>
      !(!t || "object" != typeof t) &&
      (void 0 !== t.jquery && (t = t[0]), void 0 !== t.nodeType),
    d = (t) =>
      h(t)
        ? t.jquery
          ? t[0]
          : t
        : "string" == typeof t && t.length > 0
        ? s.findOne(t)
        : null,
    u = (t, e, i) => {
      Object.keys(i).forEach((s) => {
        const n = i[s],
          o = e[s],
          r =
            o && h(o)
              ? "element"
              : null == (a = o)
              ? `${a}`
              : {}.toString
                  .call(a)
                  .match(/\s([a-z]+)/i)[1]
                  .toLowerCase();
        var a;
        if (!new RegExp(n).test(r))
          throw new TypeError(
            `${t.toUpperCase()}: Option "${s}" provided type "${r}" but expected type "${n}".`
          );
      });
    },
    g = (t) =>
      !(!h(t) || 0 === t.getClientRects().length) &&
      "visible" === getComputedStyle(t).getPropertyValue("visibility"),
    f = (t) =>
      !t ||
      t.nodeType !== Node.ELEMENT_NODE ||
      !!t.classList.contains("disabled") ||
      (void 0 !== t.disabled
        ? t.disabled
        : t.hasAttribute("disabled") && "false" !== t.getAttribute("disabled")),
    m = (t) => {
      if (!document.documentElement.attachShadow) return null;
      if ("function" == typeof t.getRootNode) {
        const e = t.getRootNode();
        return e instanceof ShadowRoot ? e : null;
      }
      return t instanceof ShadowRoot
        ? t
        : t.parentNode
        ? m(t.parentNode)
        : null;
    },
    _ = () => {},
    p = (t) => t.offsetHeight,
    b = () => {
      const { jQuery: t } = window;
      return t && !document.body.hasAttribute("data-bs-no-jquery") ? t : null;
    },
    v = [],
    y = () => "rtl" === document.documentElement.dir,
    E = (t) => {
      var e;
      (e = () => {
        const e = b();
        if (e) {
          const i = t.NAME,
            s = e.fn[i];
          (e.fn[i] = t.jQueryInterface),
            (e.fn[i].Constructor = t),
            (e.fn[i].noConflict = () => ((e.fn[i] = s), t.jQueryInterface));
        }
      }),
        "loading" === document.readyState
          ? (v.length ||
              document.addEventListener("DOMContentLoaded", () => {
                v.forEach((t) => t());
              }),
            v.push(e))
          : e();
    },
    w = (t) => {
      "function" == typeof t && t();
    },
    T = (t, e, i = !0) => {
      if (!i) return void w(t);
      const s =
        ((t) => {
          if (!t) return 0;
          let { transitionDuration: e, transitionDelay: i } =
            window.getComputedStyle(t);
          const s = Number.parseFloat(e),
            n = Number.parseFloat(i);
          return s || n
            ? ((e = e.split(",")[0]),
              (i = i.split(",")[0]),
              1e3 * (Number.parseFloat(e) + Number.parseFloat(i)))
            : 0;
        })(e) + 5;
      let o = !1;
      const r = ({ target: i }) => {
        i === e && ((o = !0), e.removeEventListener(n, r), w(t));
      };
      e.addEventListener(n, r),
        setTimeout(() => {
          o || c(e);
        }, s);
    },
    A = (t, e, i, s) => {
      let n = t.indexOf(e);
      if (-1 === n) return t[!i && s ? t.length - 1 : 0];
      const o = t.length;
      return (
        (n += i ? 1 : -1),
        s && (n = (n + o) % o),
        t[Math.max(0, Math.min(n, o - 1))]
      );
    },
    C = /[^.]*(?=\..*)\.|.*/,
    $ = /\..*/,
    L = /::\d+$/,
    k = {};
  let O = 1;
  const D = { mouseenter: "mouseover", mouseleave: "mouseout" },
    I = /^(mouseenter|mouseleave)/i,
    N = new Set([
      "click",
      "dblclick",
      "mouseup",
      "mousedown",
      "contextmenu",
      "mousewheel",
      "DOMMouseScroll",
      "mouseover",
      "mouseout",
      "mousemove",
      "selectstart",
      "selectend",
      "keydown",
      "keypress",
      "keyup",
      "orientationchange",
      "touchstart",
      "touchmove",
      "touchend",
      "touchcancel",
      "pointerdown",
      "pointermove",
      "pointerup",
      "pointerleave",
      "pointercancel",
      "gesturestart",
      "gesturechange",
      "gestureend",
      "focus",
      "blur",
      "change",
      "reset",
      "select",
      "submit",
      "focusin",
      "focusout",
      "load",
      "unload",
      "beforeunload",
      "resize",
      "move",
      "DOMContentLoaded",
      "readystatechange",
      "error",
      "abort",
      "scroll",
    ]);
  function S(t, e) {
    return (e && `${e}::${O++}`) || t.uidEvent || O++;
  }
  function x(t) {
    const e = S(t);
    return (t.uidEvent = e), (k[e] = k[e] || {}), k[e];
  }
  function M(t, e, i = null) {
    const s = Object.keys(t);
    for (let n = 0, o = s.length; n < o; n++) {
      const o = t[s[n]];
      if (o.originalHandler === e && o.delegationSelector === i) return o;
    }
    return null;
  }
  function P(t, e, i) {
    const s = "string" == typeof e,
      n = s ? i : e;
    let o = R(t);
    return N.has(o) || (o = t), [s, n, o];
  }
  function j(t, e, i, s, n) {
    if ("string" != typeof e || !t) return;
    if ((i || ((i = s), (s = null)), I.test(e))) {
      const t = (t) =>
        function (e) {
          if (
            !e.relatedTarget ||
            (e.relatedTarget !== e.delegateTarget &&
              !e.delegateTarget.contains(e.relatedTarget))
          )
            return t.call(this, e);
        };
      s ? (s = t(s)) : (i = t(i));
    }
    const [o, r, a] = P(e, i, s),
      l = x(t),
      c = l[a] || (l[a] = {}),
      h = M(c, r, o ? i : null);
    if (h) return void (h.oneOff = h.oneOff && n);
    const d = S(r, e.replace(C, "")),
      u = o
        ? (function (t, e, i) {
            return function s(n) {
              const o = t.querySelectorAll(e);
              for (let { target: r } = n; r && r !== this; r = r.parentNode)
                for (let a = o.length; a--; )
                  if (o[a] === r)
                    return (
                      (n.delegateTarget = r),
                      s.oneOff && B.off(t, n.type, e, i),
                      i.apply(r, [n])
                    );
              return null;
            };
          })(t, i, s)
        : (function (t, e) {
            return function i(s) {
              return (
                (s.delegateTarget = t),
                i.oneOff && B.off(t, s.type, e),
                e.apply(t, [s])
              );
            };
          })(t, i);
    (u.delegationSelector = o ? i : null),
      (u.originalHandler = r),
      (u.oneOff = n),
      (u.uidEvent = d),
      (c[d] = u),
      t.addEventListener(a, u, o);
  }
  function H(t, e, i, s, n) {
    const o = M(e[i], s, n);
    o && (t.removeEventListener(i, o, Boolean(n)), delete e[i][o.uidEvent]);
  }
  function R(t) {
    return (t = t.replace($, "")), D[t] || t;
  }
  const B = {
      on(t, e, i, s) {
        j(t, e, i, s, !1);
      },
      one(t, e, i, s) {
        j(t, e, i, s, !0);
      },
      off(t, e, i, s) {
        if ("string" != typeof e || !t) return;
        const [n, o, r] = P(e, i, s),
          a = r !== e,
          l = x(t),
          c = e.startsWith(".");
        if (void 0 !== o) {
          if (!l || !l[r]) return;
          return void H(t, l, r, o, n ? i : null);
        }
        c &&
          Object.keys(l).forEach((i) => {
            !(function (t, e, i, s) {
              const n = e[i] || {};
              Object.keys(n).forEach((o) => {
                if (o.includes(s)) {
                  const s = n[o];
                  H(t, e, i, s.originalHandler, s.delegationSelector);
                }
              });
            })(t, l, i, e.slice(1));
          });
        const h = l[r] || {};
        Object.keys(h).forEach((i) => {
          const s = i.replace(L, "");
          if (!a || e.includes(s)) {
            const e = h[i];
            H(t, l, r, e.originalHandler, e.delegationSelector);
          }
        });
      },
      trigger(t, e, i) {
        if ("string" != typeof e || !t) return null;
        const s = b(),
          n = R(e),
          o = e !== n,
          r = N.has(n);
        let a,
          l = !0,
          c = !0,
          h = !1,
          d = null;
        return (
          o &&
            s &&
            ((a = s.Event(e, i)),
            s(t).trigger(a),
            (l = !a.isPropagationStopped()),
            (c = !a.isImmediatePropagationStopped()),
            (h = a.isDefaultPrevented())),
          r
            ? ((d = document.createEvent("HTMLEvents")), d.initEvent(n, l, !0))
            : (d = new CustomEvent(e, { bubbles: l, cancelable: !0 })),
          void 0 !== i &&
            Object.keys(i).forEach((t) => {
              Object.defineProperty(d, t, { get: () => i[t] });
            }),
          h && d.preventDefault(),
          c && t.dispatchEvent(d),
          d.defaultPrevented && void 0 !== a && a.preventDefault(),
          d
        );
      },
    },
    W = new Map();
  var q = {
    set(t, e, i) {
      W.has(t) || W.set(t, new Map());
      const s = W.get(t);
      s.has(e) || 0 === s.size
        ? s.set(e, i)
        : console.error(
            `Bootstrap doesn't allow more than one instance per element. Bound instance: ${
              Array.from(s.keys())[0]
            }.`
          );
    },
    get: (t, e) => (W.has(t) && W.get(t).get(e)) || null,
    remove(t, e) {
      if (!W.has(t)) return;
      const i = W.get(t);
      i.delete(e), 0 === i.size && W.delete(t);
    },
  };
  class z {
    constructor(t) {
      (t = d(t)) &&
        ((this._element = t),
        q.set(this._element, this.constructor.DATA_KEY, this));
    }
    dispose() {
      q.remove(this._element, this.constructor.DATA_KEY),
        B.off(this._element, this.constructor.EVENT_KEY),
        Object.getOwnPropertyNames(this).forEach((t) => {
          this[t] = null;
        });
    }
    _queueCallback(t, e, i = !0) {
      T(t, e, i);
    }
    static getInstance(t) {
      return q.get(t, this.DATA_KEY);
    }
    static getOrCreateInstance(t, e = {}) {
      return (
        this.getInstance(t) || new this(t, "object" == typeof e ? e : null)
      );
    }
    static get VERSION() {
      return "5.0.2";
    }
    static get NAME() {
      throw new Error(
        'You have to implement the static method "NAME", for each component!'
      );
    }
    static get DATA_KEY() {
      return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
      return `.${this.DATA_KEY}`;
    }
  }
  const F = ".bs.alert",
    U = `close${F}`,
    K = `closed${F}`,
    V = `click${F}.data-api`;
  class Q extends z {
    static get NAME() {
      return "alert";
    }
    close(t) {
      const e = t ? this._getRootElement(t) : this._element,
        i = this._triggerCloseEvent(e);
      null === i || i.defaultPrevented || this._removeElement(e);
    }
    _getRootElement(t) {
      return l(t) || t.closest(".alert");
    }
    _triggerCloseEvent(t) {
      return B.trigger(t, U);
    }
    _removeElement(t) {
      t.classList.remove("show");
      const e = t.classList.contains("fade");
      this._queueCallback(() => this._destroyElement(t), t, e);
    }
    _destroyElement(t) {
      t.remove(), B.trigger(t, K);
    }
    static jQueryInterface(t) {
      return this.each(function () {
        const e = Q.getOrCreateInstance(this);
        "close" === t && e[t](this);
      });
    }
    static handleDismiss(t) {
      return function (e) {
        e && e.preventDefault(), t.close(this);
      };
    }
  }
  B.on(document, V, '[data-bs-dismiss="alert"]', Q.handleDismiss(new Q())),
    E(Q);
  const X = '[data-bs-toggle="button"]';
  class Y extends z {
    static get NAME() {
      return "button";
    }
    toggle() {
      this._element.setAttribute(
        "aria-pressed",
        this._element.classList.toggle("active")
      );
    }
    static jQueryInterface(t) {
      return this.each(function () {
        const e = Y.getOrCreateInstance(this);
        "toggle" === t && e[t]();
      });
    }
  }
  function G(t) {
    return (
      "true" === t ||
      ("false" !== t &&
        (t === Number(t).toString()
          ? Number(t)
          : "" === t || "null" === t
          ? null
          : t))
    );
  }
  function Z(t) {
    return t.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`);
  }
  B.on(document, "click.bs.button.data-api", X, (t) => {
    t.preventDefault();
    const e = t.target.closest(X);
    Y.getOrCreateInstance(e).toggle();
  }),
    E(Y);
  const J = {
      setDataAttribute(t, e, i) {
        t.setAttribute(`data-bs-${Z(e)}`, i);
      },
      removeDataAttribute(t, e) {
        t.removeAttribute(`data-bs-${Z(e)}`);
      },
      getDataAttributes(t) {
        if (!t) return {};
        const e = {};
        return (
          Object.keys(t.dataset)
            .filter((t) => t.startsWith("bs"))
            .forEach((i) => {
              let s = i.replace(/^bs/, "");
              (s = s.charAt(0).toLowerCase() + s.slice(1, s.length)),
                (e[s] = G(t.dataset[i]));
            }),
          e
        );
      },
      getDataAttribute: (t, e) => G(t.getAttribute(`data-bs-${Z(e)}`)),
      offset(t) {
        const e = t.getBoundingClientRect();
        return {
          top: e.top + document.body.scrollTop,
          left: e.left + document.body.scrollLeft,
        };
      },
      position: (t) => ({ top: t.offsetTop, left: t.offsetLeft }),
    },
    tt = "carousel",
    et = ".bs.carousel",
    it = ".data-api",
    st = {
      interval: 5e3,
      keyboard: !0,
      slide: !1,
      pause: "hover",
      wrap: !0,
      touch: !0,
    },
    nt = {
      interval: "(number|boolean)",
      keyboard: "boolean",
      slide: "(boolean|string)",
      pause: "(string|boolean)",
      wrap: "boolean",
      touch: "boolean",
    },
    ot = "next",
    rt = "prev",
    at = "left",
    lt = "right",
    ct = { ArrowLeft: lt, ArrowRight: at },
    ht = `slide${et}`,
    dt = `slid${et}`,
    ut = `keydown${et}`,
    gt = `mouseenter${et}`,
    ft = `mouseleave${et}`,
    mt = `touchstart${et}`,
    _t = `touchmove${et}`,
    pt = `touchend${et}`,
    bt = `pointerdown${et}`,
    vt = `pointerup${et}`,
    yt = `dragstart${et}`,
    Et = `load${et}${it}`,
    wt = `click${et}${it}`,
    Tt = "active",
    At = ".active.carousel-item",
    Ct = "touch";
  class $t extends z {
    constructor(t, e) {
      super(t),
        (this._items = null),
        (this._interval = null),
        (this._activeElement = null),
        (this._isPaused = !1),
        (this._isSliding = !1),
        (this.touchTimeout = null),
        (this.touchStartX = 0),
        (this.touchDeltaX = 0),
        (this._config = this._getConfig(e)),
        (this._indicatorsElement = s.findOne(
          ".carousel-indicators",
          this._element
        )),
        (this._touchSupported =
          "ontouchstart" in document.documentElement ||
          navigator.maxTouchPoints > 0),
        (this._pointerEvent = Boolean(window.PointerEvent)),
        this._addEventListeners();
    }
    static get Default() {
      return st;
    }
    static get NAME() {
      return tt;
    }
    next() {
      this._slide(ot);
    }
    nextWhenVisible() {
      !document.hidden && g(this._element) && this.next();
    }
    prev() {
      this._slide(rt);
    }
    pause(t) {
      t || (this._isPaused = !0),
        s.findOne(".carousel-item-next, .carousel-item-prev", this._element) &&
          (c(this._element), this.cycle(!0)),
        clearInterval(this._interval),
        (this._interval = null);
    }
    cycle(t) {
      t || (this._isPaused = !1),
        this._interval &&
          (clearInterval(this._interval), (this._interval = null)),
        this._config &&
          this._config.interval &&
          !this._isPaused &&
          (this._updateInterval(),
          (this._interval = setInterval(
            (document.visibilityState ? this.nextWhenVisible : this.next).bind(
              this
            ),
            this._config.interval
          )));
    }
    to(t) {
      this._activeElement = s.findOne(At, this._element);
      const e = this._getItemIndex(this._activeElement);
      if (t > this._items.length - 1 || t < 0) return;
      if (this._isSliding)
        return void B.one(this._element, dt, () => this.to(t));
      if (e === t) return this.pause(), void this.cycle();
      const i = t > e ? ot : rt;
      this._slide(i, this._items[t]);
    }
    _getConfig(t) {
      return (
        (t = {
          ...st,
          ...J.getDataAttributes(this._element),
          ...("object" == typeof t ? t : {}),
        }),
        u(tt, t, nt),
        t
      );
    }
    _handleSwipe() {
      const t = Math.abs(this.touchDeltaX);
      if (t <= 40) return;
      const e = t / this.touchDeltaX;
      (this.touchDeltaX = 0), e && this._slide(e > 0 ? lt : at);
    }
    _addEventListeners() {
      this._config.keyboard && B.on(this._element, ut, (t) => this._keydown(t)),
        "hover" === this._config.pause &&
          (B.on(this._element, gt, (t) => this.pause(t)),
          B.on(this._element, ft, (t) => this.cycle(t))),
        this._config.touch &&
          this._touchSupported &&
          this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
      const t = (t) => {
          !this._pointerEvent ||
          ("pen" !== t.pointerType && t.pointerType !== Ct)
            ? this._pointerEvent || (this.touchStartX = t.touches[0].clientX)
            : (this.touchStartX = t.clientX);
        },
        e = (t) => {
          this.touchDeltaX =
            t.touches && t.touches.length > 1
              ? 0
              : t.touches[0].clientX - this.touchStartX;
        },
        i = (t) => {
          !this._pointerEvent ||
            ("pen" !== t.pointerType && t.pointerType !== Ct) ||
            (this.touchDeltaX = t.clientX - this.touchStartX),
            this._handleSwipe(),
            "hover" === this._config.pause &&
              (this.pause(),
              this.touchTimeout && clearTimeout(this.touchTimeout),
              (this.touchTimeout = setTimeout(
                (t) => this.cycle(t),
                500 + this._config.interval
              )));
        };
      s.find(".carousel-item img", this._element).forEach((t) => {
        B.on(t, yt, (t) => t.preventDefault());
      }),
        this._pointerEvent
          ? (B.on(this._element, bt, (e) => t(e)),
            B.on(this._element, vt, (t) => i(t)),
            this._element.classList.add("pointer-event"))
          : (B.on(this._element, mt, (e) => t(e)),
            B.on(this._element, _t, (t) => e(t)),
            B.on(this._element, pt, (t) => i(t)));
    }
    _keydown(t) {
      if (/input|textarea/i.test(t.target.tagName)) return;
      const e = ct[t.key];
      e && (t.preventDefault(), this._slide(e));
    }
    _getItemIndex(t) {
      return (
        (this._items =
          t && t.parentNode ? s.find(".carousel-item", t.parentNode) : []),
        this._items.indexOf(t)
      );
    }
    _getItemByOrder(t, e) {
      const i = t === ot;
      return A(this._items, e, i, this._config.wrap);
    }
    _triggerSlideEvent(t, e) {
      const i = this._getItemIndex(t),
        n = this._getItemIndex(s.findOne(At, this._element));
      return B.trigger(this._element, ht, {
        relatedTarget: t,
        direction: e,
        from: n,
        to: i,
      });
    }
    _setActiveIndicatorElement(t) {
      if (this._indicatorsElement) {
        const e = s.findOne(".active", this._indicatorsElement);
        e.classList.remove(Tt), e.removeAttribute("aria-current");
        const i = s.find("[data-bs-target]", this._indicatorsElement);
        for (let e = 0; e < i.length; e++)
          if (
            Number.parseInt(i[e].getAttribute("data-bs-slide-to"), 10) ===
            this._getItemIndex(t)
          ) {
            i[e].classList.add(Tt), i[e].setAttribute("aria-current", "true");
            break;
          }
      }
    }
    _updateInterval() {
      const t = this._activeElement || s.findOne(At, this._element);
      if (!t) return;
      const e = Number.parseInt(t.getAttribute("data-bs-interval"), 10);
      e
        ? ((this._config.defaultInterval =
            this._config.defaultInterval || this._config.interval),
          (this._config.interval = e))
        : (this._config.interval =
            this._config.defaultInterval || this._config.interval);
    }
    _slide(t, e) {
      const i = this._directionToOrder(t),
        n = s.findOne(At, this._element),
        o = this._getItemIndex(n),
        r = e || this._getItemByOrder(i, n),
        a = this._getItemIndex(r),
        l = Boolean(this._interval),
        c = i === ot,
        h = c ? "carousel-item-start" : "carousel-item-end",
        d = c ? "carousel-item-next" : "carousel-item-prev",
        u = this._orderToDirection(i);
      if (r && r.classList.contains(Tt)) return void (this._isSliding = !1);
      if (this._isSliding) return;
      if (this._triggerSlideEvent(r, u).defaultPrevented) return;
      if (!n || !r) return;
      (this._isSliding = !0),
        l && this.pause(),
        this._setActiveIndicatorElement(r),
        (this._activeElement = r);
      const g = () => {
        B.trigger(this._element, dt, {
          relatedTarget: r,
          direction: u,
          from: o,
          to: a,
        });
      };
      if (this._element.classList.contains("slide")) {
        r.classList.add(d), p(r), n.classList.add(h), r.classList.add(h);
        const t = () => {
          r.classList.remove(h, d),
            r.classList.add(Tt),
            n.classList.remove(Tt, d, h),
            (this._isSliding = !1),
            setTimeout(g, 0);
        };
        this._queueCallback(t, n, !0);
      } else n.classList.remove(Tt), r.classList.add(Tt), (this._isSliding = !1), g();
      l && this.cycle();
    }
    _directionToOrder(t) {
      return [lt, at].includes(t)
        ? y()
          ? t === at
            ? rt
            : ot
          : t === at
          ? ot
          : rt
        : t;
    }
    _orderToDirection(t) {
      return [ot, rt].includes(t)
        ? y()
          ? t === rt
            ? at
            : lt
          : t === rt
          ? lt
          : at
        : t;
    }
    static carouselInterface(t, e) {
      const i = $t.getOrCreateInstance(t, e);
      let { _config: s } = i;
      "object" == typeof e && (s = { ...s, ...e });
      const n = "string" == typeof e ? e : s.slide;
      if ("number" == typeof e) i.to(e);
      else if ("string" == typeof n) {
        if (void 0 === i[n]) throw new TypeError(`No method named "${n}"`);
        i[n]();
      } else s.interval && s.ride && (i.pause(), i.cycle());
    }
    static jQueryInterface(t) {
      return this.each(function () {
        $t.carouselInterface(this, t);
      });
    }
    static dataApiClickHandler(t) {
      const e = l(this);
      if (!e || !e.classList.contains("carousel")) return;
      const i = { ...J.getDataAttributes(e), ...J.getDataAttributes(this) },
        s = this.getAttribute("data-bs-slide-to");
      s && (i.interval = !1),
        $t.carouselInterface(e, i),
        s && $t.getInstance(e).to(s),
        t.preventDefault();
    }
  }
  B.on(
    document,
    wt,
    "[data-bs-slide], [data-bs-slide-to]",
    $t.dataApiClickHandler
  ),
    B.on(window, Et, () => {
      const t = s.find('[data-bs-ride="carousel"]');
      for (let e = 0, i = t.length; e < i; e++)
        $t.carouselInterface(t[e], $t.getInstance(t[e]));
    }),
    E($t);
  const Lt = "collapse",
    kt = "bs.collapse",
    Ot = `.${kt}`,
    Dt = { toggle: !0, parent: "" },
    It = { toggle: "boolean", parent: "(string|element)" },
    Nt = `show${Ot}`,
    St = `shown${Ot}`,
    xt = `hide${Ot}`,
    Mt = `hidden${Ot}`,
    Pt = `click${Ot}.data-api`,
    jt = "show",
    Ht = "collapse",
    Rt = "collapsing",
    Bt = "collapsed",
    Wt = "width",
    qt = '[data-bs-toggle="collapse"]';
  class zt extends z {
    constructor(t, e) {
      super(t),
        (this._isTransitioning = !1),
        (this._config = this._getConfig(e)),
        (this._triggerArray = s.find(
          `${qt}[href="#${this._element.id}"],${qt}[data-bs-target="#${this._element.id}"]`
        ));
      const i = s.find(qt);
      for (let t = 0, e = i.length; t < e; t++) {
        const e = i[t],
          n = a(e),
          o = s.find(n).filter((t) => t === this._element);
        null !== n &&
          o.length &&
          ((this._selector = n), this._triggerArray.push(e));
      }
      (this._parent = this._config.parent ? this._getParent() : null),
        this._config.parent ||
          this._addAriaAndCollapsedClass(this._element, this._triggerArray),
        this._config.toggle && this.toggle();
    }
    static get Default() {
      return Dt;
    }
    static get NAME() {
      return Lt;
    }
    toggle() {
      this._element.classList.contains(jt) ? this.hide() : this.show();
    }
    show() {
      if (this._isTransitioning || this._element.classList.contains(jt)) return;
      let t, e;
      this._parent &&
        ((t = s
          .find(".show, .collapsing", this._parent)
          .filter((t) =>
            "string" == typeof this._config.parent
              ? t.getAttribute("data-bs-parent") === this._config.parent
              : t.classList.contains(Ht)
          )),
        0 === t.length && (t = null));
      const i = s.findOne(this._selector);
      if (t) {
        const s = t.find((t) => i !== t);
        if (((e = s ? zt.getInstance(s) : null), e && e._isTransitioning))
          return;
      }
      if (B.trigger(this._element, Nt).defaultPrevented) return;
      t &&
        t.forEach((t) => {
          i !== t && zt.collapseInterface(t, "hide"), e || q.set(t, kt, null);
        });
      const n = this._getDimension();
      this._element.classList.remove(Ht),
        this._element.classList.add(Rt),
        (this._element.style[n] = 0),
        this._triggerArray.length &&
          this._triggerArray.forEach((t) => {
            t.classList.remove(Bt), t.setAttribute("aria-expanded", !0);
          }),
        this.setTransitioning(!0);
      const o = `scroll${n[0].toUpperCase() + n.slice(1)}`;
      this._queueCallback(
        () => {
          this._element.classList.remove(Rt),
            this._element.classList.add(Ht, jt),
            (this._element.style[n] = ""),
            this.setTransitioning(!1),
            B.trigger(this._element, St);
        },
        this._element,
        !0
      ),
        (this._element.style[n] = `${this._element[o]}px`);
    }
    hide() {
      if (this._isTransitioning || !this._element.classList.contains(jt))
        return;
      if (B.trigger(this._element, xt).defaultPrevented) return;
      const t = this._getDimension();
      (this._element.style[t] = `${
        this._element.getBoundingClientRect()[t]
      }px`),
        p(this._element),
        this._element.classList.add(Rt),
        this._element.classList.remove(Ht, jt);
      const e = this._triggerArray.length;
      if (e > 0)
        for (let t = 0; t < e; t++) {
          const e = this._triggerArray[t],
            i = l(e);
          i &&
            !i.classList.contains(jt) &&
            (e.classList.add(Bt), e.setAttribute("aria-expanded", !1));
        }
      this.setTransitioning(!0);
      (this._element.style[t] = ""),
        this._queueCallback(
          () => {
            this.setTransitioning(!1),
              this._element.classList.remove(Rt),
              this._element.classList.add(Ht),
              B.trigger(this._element, Mt);
          },
          this._element,
          !0
        );
    }
    setTransitioning(t) {
      this._isTransitioning = t;
    }
    _getConfig(t) {
      return (
        ((t = { ...Dt, ...t }).toggle = Boolean(t.toggle)), u(Lt, t, It), t
      );
    }
    _getDimension() {
      return this._element.classList.contains(Wt) ? Wt : "height";
    }
    _getParent() {
      let { parent: t } = this._config;
      t = d(t);
      const e = `${qt}[data-bs-parent="${t}"]`;
      return (
        s.find(e, t).forEach((t) => {
          const e = l(t);
          this._addAriaAndCollapsedClass(e, [t]);
        }),
        t
      );
    }
    _addAriaAndCollapsedClass(t, e) {
      if (!t || !e.length) return;
      const i = t.classList.contains(jt);
      e.forEach((t) => {
        i ? t.classList.remove(Bt) : t.classList.add(Bt),
          t.setAttribute("aria-expanded", i);
      });
    }
    static collapseInterface(t, e) {
      let i = zt.getInstance(t);
      const s = {
        ...Dt,
        ...J.getDataAttributes(t),
        ...("object" == typeof e && e ? e : {}),
      };
      if (
        (!i &&
          s.toggle &&
          "string" == typeof e &&
          /show|hide/.test(e) &&
          (s.toggle = !1),
        i || (i = new zt(t, s)),
        "string" == typeof e)
      ) {
        if (void 0 === i[e]) throw new TypeError(`No method named "${e}"`);
        i[e]();
      }
    }
    static jQueryInterface(t) {
      return this.each(function () {
        zt.collapseInterface(this, t);
      });
    }
  }
  B.on(document, Pt, qt, function (t) {
    ("A" === t.target.tagName ||
      (t.delegateTarget && "A" === t.delegateTarget.tagName)) &&
      t.preventDefault();
    const e = J.getDataAttributes(this),
      i = a(this);
    s.find(i).forEach((t) => {
      const i = zt.getInstance(t);
      let s;
      i
        ? (null === i._parent &&
            "string" == typeof e.parent &&
            ((i._config.parent = e.parent), (i._parent = i._getParent())),
          (s = "toggle"))
        : (s = e),
        zt.collapseInterface(t, s);
    });
  }),
    E(zt);
  const Ft = "dropdown",
    Ut = ".bs.dropdown",
    Kt = ".data-api",
    Vt = "Escape",
    Qt = "Space",
    Xt = "ArrowUp",
    Yt = "ArrowDown",
    Gt = new RegExp(`${Xt}|${Yt}|${Vt}`),
    Zt = `hide${Ut}`,
    Jt = `hidden${Ut}`,
    te = `show${Ut}`,
    ee = `shown${Ut}`,
    ie = `click${Ut}`,
    se = `click${Ut}${Kt}`,
    ne = `keydown${Ut}${Kt}`,
    oe = `keyup${Ut}${Kt}`,
    re = "show",
    ae = '[data-bs-toggle="dropdown"]',
    le = ".dropdown-menu",
    ce = y() ? "top-end" : "top-start",
    he = y() ? "top-start" : "top-end",
    de = y() ? "bottom-end" : "bottom-start",
    ue = y() ? "bottom-start" : "bottom-end",
    ge = y() ? "left-start" : "right-start",
    fe = y() ? "right-start" : "left-start",
    me = {
      offset: [0, 2],
      boundary: "clippingParents",
      reference: "toggle",
      display: "dynamic",
      popperConfig: null,
      autoClose: !0,
    },
    _e = {
      offset: "(array|string|function)",
      boundary: "(string|element)",
      reference: "(string|element|object)",
      display: "string",
      popperConfig: "(null|object|function)",
      autoClose: "(boolean|string)",
    };
  class pe extends z {
    constructor(t, e) {
      super(t),
        (this._popper = null),
        (this._config = this._getConfig(e)),
        (this._menu = this._getMenuElement()),
        (this._inNavbar = this._detectNavbar()),
        this._addEventListeners();
    }
    static get Default() {
      return me;
    }
    static get DefaultType() {
      return _e;
    }
    static get NAME() {
      return Ft;
    }
    toggle() {
      if (f(this._element)) return;
      this._element.classList.contains(re) ? this.hide() : this.show();
    }
    show() {
      if (f(this._element) || this._menu.classList.contains(re)) return;
      const t = pe.getParentFromElement(this._element),
        e = { relatedTarget: this._element };
      if (!B.trigger(this._element, te, e).defaultPrevented) {
        if (this._inNavbar) J.setDataAttribute(this._menu, "popper", "none");
        else {
          if (void 0 === i)
            throw new TypeError(
              "Bootstrap's dropdowns require Popper (https://popper.js.org)"
            );
          let e = this._element;
          "parent" === this._config.reference
            ? (e = t)
            : h(this._config.reference)
            ? (e = d(this._config.reference))
            : "object" == typeof this._config.reference &&
              (e = this._config.reference);
          const s = this._getPopperConfig(),
            n = s.modifiers.find(
              (t) => "applyStyles" === t.name && !1 === t.enabled
            );
          (this._popper = i.createPopper(e, this._menu, s)),
            n && J.setDataAttribute(this._menu, "popper", "static");
        }
        "ontouchstart" in document.documentElement &&
          !t.closest(".navbar-nav") &&
          []
            .concat(...document.body.children)
            .forEach((t) => B.on(t, "mouseover", _)),
          this._element.focus(),
          this._element.setAttribute("aria-expanded", !0),
          this._menu.classList.toggle(re),
          this._element.classList.toggle(re),
          B.trigger(this._element, ee, e);
      }
    }
    hide() {
      if (f(this._element) || !this._menu.classList.contains(re)) return;
      const t = { relatedTarget: this._element };
      this._completeHide(t);
    }
    dispose() {
      this._popper && this._popper.destroy(), super.dispose();
    }
    update() {
      (this._inNavbar = this._detectNavbar()),
        this._popper && this._popper.update();
    }
    _addEventListeners() {
      B.on(this._element, ie, (t) => {
        t.preventDefault(), this.toggle();
      });
    }
    _completeHide(t) {
      B.trigger(this._element, Zt, t).defaultPrevented ||
        ("ontouchstart" in document.documentElement &&
          []
            .concat(...document.body.children)
            .forEach((t) => B.off(t, "mouseover", _)),
        this._popper && this._popper.destroy(),
        this._menu.classList.remove(re),
        this._element.classList.remove(re),
        this._element.setAttribute("aria-expanded", "false"),
        J.removeDataAttribute(this._menu, "popper"),
        B.trigger(this._element, Jt, t));
    }
    _getConfig(t) {
      if (
        ((t = {
          ...this.constructor.Default,
          ...J.getDataAttributes(this._element),
          ...t,
        }),
        u(Ft, t, this.constructor.DefaultType),
        "object" == typeof t.reference &&
          !h(t.reference) &&
          "function" != typeof t.reference.getBoundingClientRect)
      )
        throw new TypeError(
          `${Ft.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`
        );
      return t;
    }
    _getMenuElement() {
      return s.next(this._element, le)[0];
    }
    _getPlacement() {
      const t = this._element.parentNode;
      if (t.classList.contains("dropend")) return ge;
      if (t.classList.contains("dropstart")) return fe;
      const e =
        "end" ===
        getComputedStyle(this._menu).getPropertyValue("--bs-position").trim();
      return t.classList.contains("dropup") ? (e ? he : ce) : e ? ue : de;
    }
    _detectNavbar() {
      return null !== this._element.closest(".navbar");
    }
    _getOffset() {
      const { offset: t } = this._config;
      return "string" == typeof t
        ? t.split(",").map((t) => Number.parseInt(t, 10))
        : "function" == typeof t
        ? (e) => t(e, this._element)
        : t;
    }
    _getPopperConfig() {
      const t = {
        placement: this._getPlacement(),
        modifiers: [
          {
            name: "preventOverflow",
            options: { boundary: this._config.boundary },
          },
          { name: "offset", options: { offset: this._getOffset() } },
        ],
      };
      return (
        "static" === this._config.display &&
          (t.modifiers = [{ name: "applyStyles", enabled: !1 }]),
        {
          ...t,
          ...("function" == typeof this._config.popperConfig
            ? this._config.popperConfig(t)
            : this._config.popperConfig),
        }
      );
    }
    _selectMenuItem({ key: t, target: e }) {
      const i = s
        .find(
          ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",
          this._menu
        )
        .filter(g);
      i.length && A(i, e, t === Yt, !i.includes(e)).focus();
    }
    static dropdownInterface(t, e) {
      const i = pe.getOrCreateInstance(t, e);
      if ("string" == typeof e) {
        if (void 0 === i[e]) throw new TypeError(`No method named "${e}"`);
        i[e]();
      }
    }
    static jQueryInterface(t) {
      return this.each(function () {
        pe.dropdownInterface(this, t);
      });
    }
    static clearMenus(t) {
      if (t && (2 === t.button || ("keyup" === t.type && "Tab" !== t.key)))
        return;
      const e = s.find(ae);
      for (let i = 0, s = e.length; i < s; i++) {
        const s = pe.getInstance(e[i]);
        if (!s || !1 === s._config.autoClose) continue;
        if (!s._element.classList.contains(re)) continue;
        const n = { relatedTarget: s._element };
        if (t) {
          const e = t.composedPath(),
            i = e.includes(s._menu);
          if (
            e.includes(s._element) ||
            ("inside" === s._config.autoClose && !i) ||
            ("outside" === s._config.autoClose && i)
          )
            continue;
          if (
            s._menu.contains(t.target) &&
            (("keyup" === t.type && "Tab" === t.key) ||
              /input|select|option|textarea|form/i.test(t.target.tagName))
          )
            continue;
          "click" === t.type && (n.clickEvent = t);
        }
        s._completeHide(n);
      }
    }
    static getParentFromElement(t) {
      return l(t) || t.parentNode;
    }
    static dataApiKeydownHandler(t) {
      if (
        /input|textarea/i.test(t.target.tagName)
          ? t.key === Qt ||
            (t.key !== Vt &&
              ((t.key !== Yt && t.key !== Xt) || t.target.closest(le)))
          : !Gt.test(t.key)
      )
        return;
      const e = this.classList.contains(re);
      if (!e && t.key === Vt) return;
      if ((t.preventDefault(), t.stopPropagation(), f(this))) return;
      const i = () => (this.matches(ae) ? this : s.prev(this, ae)[0]);
      return t.key === Vt
        ? (i().focus(), void pe.clearMenus())
        : t.key === Xt || t.key === Yt
        ? (e || i().click(), void pe.getInstance(i())._selectMenuItem(t))
        : void ((e && t.key !== Qt) || pe.clearMenus());
    }
  }
  B.on(document, ne, ae, pe.dataApiKeydownHandler),
    B.on(document, ne, le, pe.dataApiKeydownHandler),
    B.on(document, se, pe.clearMenus),
    B.on(document, oe, pe.clearMenus),
    B.on(document, se, ae, function (t) {
      t.preventDefault(), pe.dropdownInterface(this);
    }),
    E(pe);
  const be = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
    ve = ".sticky-top";
  class ye {
    constructor() {
      this._element = document.body;
    }
    getWidth() {
      const t = document.documentElement.clientWidth;
      return Math.abs(window.innerWidth - t);
    }
    hide() {
      const t = this.getWidth();
      this._disableOverFlow(),
        this._setElementAttributes(this._element, "paddingRight", (e) => e + t),
        this._setElementAttributes(be, "paddingRight", (e) => e + t),
        this._setElementAttributes(ve, "marginRight", (e) => e - t);
    }
    _disableOverFlow() {
      this._saveInitialAttribute(this._element, "overflow"),
        (this._element.style.overflow = "hidden");
    }
    _setElementAttributes(t, e, i) {
      const s = this.getWidth();
      this._applyManipulationCallback(t, (t) => {
        if (t !== this._element && window.innerWidth > t.clientWidth + s)
          return;
        this._saveInitialAttribute(t, e);
        const n = window.getComputedStyle(t)[e];
        t.style[e] = `${i(Number.parseFloat(n))}px`;
      });
    }
    reset() {
      this._resetElementAttributes(this._element, "overflow"),
        this._resetElementAttributes(this._element, "paddingRight"),
        this._resetElementAttributes(be, "paddingRight"),
        this._resetElementAttributes(ve, "marginRight");
    }
    _saveInitialAttribute(t, e) {
      const i = t.style[e];
      i && J.setDataAttribute(t, e, i);
    }
    _resetElementAttributes(t, e) {
      this._applyManipulationCallback(t, (t) => {
        const i = J.getDataAttribute(t, e);
        void 0 === i
          ? t.style.removeProperty(e)
          : (J.removeDataAttribute(t, e), (t.style[e] = i));
      });
    }
    _applyManipulationCallback(t, e) {
      h(t) ? e(t) : s.find(t, this._element).forEach(e);
    }
    isOverflowing() {
      return this.getWidth() > 0;
    }
  }
  const Ee = {
      isVisible: !0,
      isAnimated: !1,
      rootElement: "body",
      clickCallback: null,
    },
    we = {
      isVisible: "boolean",
      isAnimated: "boolean",
      rootElement: "(element|string)",
      clickCallback: "(function|null)",
    },
    Te = "backdrop",
    Ae = "show",
    Ce = `mousedown.bs.${Te}`;
  class $e {
    constructor(t) {
      (this._config = this._getConfig(t)),
        (this._isAppended = !1),
        (this._element = null);
    }
    show(t) {
      this._config.isVisible
        ? (this._append(),
          this._config.isAnimated && p(this._getElement()),
          this._getElement().classList.add(Ae),
          this._emulateAnimation(() => {
            w(t);
          }))
        : w(t);
    }
    hide(t) {
      this._config.isVisible
        ? (this._getElement().classList.remove(Ae),
          this._emulateAnimation(() => {
            this.dispose(), w(t);
          }))
        : w(t);
    }
    _getElement() {
      if (!this._element) {
        const t = document.createElement("div");
        (t.className = "modal-backdrop"),
          this._config.isAnimated && t.classList.add("fade"),
          (this._element = t);
      }
      return this._element;
    }
    _getConfig(t) {
      return (
        ((t = { ...Ee, ...("object" == typeof t ? t : {}) }).rootElement = d(
          t.rootElement
        )),
        u(Te, t, we),
        t
      );
    }
    _append() {
      this._isAppended ||
        (this._config.rootElement.appendChild(this._getElement()),
        B.on(this._getElement(), Ce, () => {
          w(this._config.clickCallback);
        }),
        (this._isAppended = !0));
    }
    dispose() {
      this._isAppended &&
        (B.off(this._element, Ce),
        this._element.remove(),
        (this._isAppended = !1));
    }
    _emulateAnimation(t) {
      T(t, this._getElement(), this._config.isAnimated);
    }
  }
  const Le = "modal",
    ke = ".bs.modal",
    Oe = "Escape",
    De = { backdrop: !0, keyboard: !0, focus: !0 },
    Ie = {
      backdrop: "(boolean|string)",
      keyboard: "boolean",
      focus: "boolean",
    },
    Ne = `hide${ke}`,
    Se = `hidePrevented${ke}`,
    xe = `hidden${ke}`,
    Me = `show${ke}`,
    Pe = `shown${ke}`,
    je = `focusin${ke}`,
    He = `resize${ke}`,
    Re = `click.dismiss${ke}`,
    Be = `keydown.dismiss${ke}`,
    We = `mouseup.dismiss${ke}`,
    qe = `mousedown.dismiss${ke}`,
    ze = `click${ke}.data-api`,
    Fe = "modal-open",
    Ue = "show",
    Ke = "modal-static";
  class Ve extends z {
    constructor(t, e) {
      super(t),
        (this._config = this._getConfig(e)),
        (this._dialog = s.findOne(".modal-dialog", this._element)),
        (this._backdrop = this._initializeBackDrop()),
        (this._isShown = !1),
        (this._ignoreBackdropClick = !1),
        (this._isTransitioning = !1),
        (this._scrollBar = new ye());
    }
    static get Default() {
      return De;
    }
    static get NAME() {
      return Le;
    }
    toggle(t) {
      return this._isShown ? this.hide() : this.show(t);
    }
    show(t) {
      if (this._isShown || this._isTransitioning) return;
      B.trigger(this._element, Me, { relatedTarget: t }).defaultPrevented ||
        ((this._isShown = !0),
        this._isAnimated() && (this._isTransitioning = !0),
        this._scrollBar.hide(),
        document.body.classList.add(Fe),
        this._adjustDialog(),
        this._setEscapeEvent(),
        this._setResizeEvent(),
        B.on(this._element, Re, '[data-bs-dismiss="modal"]', (t) =>
          this.hide(t)
        ),
        B.on(this._dialog, qe, () => {
          B.one(this._element, We, (t) => {
            t.target === this._element && (this._ignoreBackdropClick = !0);
          });
        }),
        this._showBackdrop(() => this._showElement(t)));
    }
    hide(t) {
      if (
        (t && ["A", "AREA"].includes(t.target.tagName) && t.preventDefault(),
        !this._isShown || this._isTransitioning)
      )
        return;
      if (B.trigger(this._element, Ne).defaultPrevented) return;
      this._isShown = !1;
      const e = this._isAnimated();
      e && (this._isTransitioning = !0),
        this._setEscapeEvent(),
        this._setResizeEvent(),
        B.off(document, je),
        this._element.classList.remove(Ue),
        B.off(this._element, Re),
        B.off(this._dialog, qe),
        this._queueCallback(() => this._hideModal(), this._element, e);
    }
    dispose() {
      [window, this._dialog].forEach((t) => B.off(t, ke)),
        this._backdrop.dispose(),
        super.dispose(),
        B.off(document, je);
    }
    handleUpdate() {
      this._adjustDialog();
    }
    _initializeBackDrop() {
      return new $e({
        isVisible: Boolean(this._config.backdrop),
        isAnimated: this._isAnimated(),
      });
    }
    _getConfig(t) {
      return (
        (t = {
          ...De,
          ...J.getDataAttributes(this._element),
          ...("object" == typeof t ? t : {}),
        }),
        u(Le, t, Ie),
        t
      );
    }
    _showElement(t) {
      const e = this._isAnimated(),
        i = s.findOne(".modal-body", this._dialog);
      (this._element.parentNode &&
        this._element.parentNode.nodeType === Node.ELEMENT_NODE) ||
        document.body.appendChild(this._element),
        (this._element.style.display = "block"),
        this._element.removeAttribute("aria-hidden"),
        this._element.setAttribute("aria-modal", !0),
        this._element.setAttribute("role", "dialog"),
        (this._element.scrollTop = 0),
        i && (i.scrollTop = 0),
        e && p(this._element),
        this._element.classList.add(Ue),
        this._config.focus && this._enforceFocus();
      this._queueCallback(
        () => {
          this._config.focus && this._element.focus(),
            (this._isTransitioning = !1),
            B.trigger(this._element, Pe, { relatedTarget: t });
        },
        this._dialog,
        e
      );
    }
    _enforceFocus() {
      B.off(document, je),
        B.on(document, je, (t) => {
          document === t.target ||
            this._element === t.target ||
            this._element.contains(t.target) ||
            this._element.focus();
        });
    }
    _setEscapeEvent() {
      this._isShown
        ? B.on(this._element, Be, (t) => {
            this._config.keyboard && t.key === Oe
              ? (t.preventDefault(), this.hide())
              : this._config.keyboard ||
                t.key !== Oe ||
                this._triggerBackdropTransition();
          })
        : B.off(this._element, Be);
    }
    _setResizeEvent() {
      this._isShown
        ? B.on(window, He, () => this._adjustDialog())
        : B.off(window, He);
    }
    _hideModal() {
      (this._element.style.display = "none"),
        this._element.setAttribute("aria-hidden", !0),
        this._element.removeAttribute("aria-modal"),
        this._element.removeAttribute("role"),
        (this._isTransitioning = !1),
        this._backdrop.hide(() => {
          document.body.classList.remove(Fe),
            this._resetAdjustments(),
            this._scrollBar.reset(),
            B.trigger(this._element, xe);
        });
    }
    _showBackdrop(t) {
      B.on(this._element, Re, (t) => {
        this._ignoreBackdropClick
          ? (this._ignoreBackdropClick = !1)
          : t.target === t.currentTarget &&
            (!0 === this._config.backdrop
              ? this.hide()
              : "static" === this._config.backdrop &&
                this._triggerBackdropTransition());
      }),
        this._backdrop.show(t);
    }
    _isAnimated() {
      return this._element.classList.contains("fade");
    }
    _triggerBackdropTransition() {
      if (B.trigger(this._element, Se).defaultPrevented) return;
      const { classList: t, scrollHeight: e, style: i } = this._element,
        s = e > document.documentElement.clientHeight;
      (!s && "hidden" === i.overflowY) ||
        t.contains(Ke) ||
        (s || (i.overflowY = "hidden"),
        t.add(Ke),
        this._queueCallback(() => {
          t.remove(Ke),
            s ||
              this._queueCallback(() => {
                i.overflowY = "";
              }, this._dialog);
        }, this._dialog),
        this._element.focus());
    }
    _adjustDialog() {
      const t =
          this._element.scrollHeight > document.documentElement.clientHeight,
        e = this._scrollBar.getWidth(),
        i = e > 0;
      ((!i && t && !y()) || (i && !t && y())) &&
        (this._element.style.paddingLeft = `${e}px`),
        ((i && !t && !y()) || (!i && t && y())) &&
          (this._element.style.paddingRight = `${e}px`);
    }
    _resetAdjustments() {
      (this._element.style.paddingLeft = ""),
        (this._element.style.paddingRight = "");
    }
    static jQueryInterface(t, e) {
      return this.each(function () {
        const i = Ve.getOrCreateInstance(this, t);
        if ("string" == typeof t) {
          if (void 0 === i[t]) throw new TypeError(`No method named "${t}"`);
          i[t](e);
        }
      });
    }
  }
  B.on(document, ze, '[data-bs-toggle="modal"]', function (t) {
    const e = l(this);
    ["A", "AREA"].includes(this.tagName) && t.preventDefault(),
      B.one(e, Me, (t) => {
        t.defaultPrevented ||
          B.one(e, xe, () => {
            g(this) && this.focus();
          });
      });
    Ve.getOrCreateInstance(e).toggle(this);
  }),
    E(Ve);
  const Qe = "offcanvas",
    Xe = ".bs.offcanvas",
    Ye = ".data-api",
    Ge = `load${Xe}${Ye}`,
    Ze = { backdrop: !0, keyboard: !0, scroll: !1 },
    Je = { backdrop: "boolean", keyboard: "boolean", scroll: "boolean" },
    ti = "show",
    ei = ".offcanvas.show",
    ii = `show${Xe}`,
    si = `shown${Xe}`,
    ni = `hide${Xe}`,
    oi = `hidden${Xe}`,
    ri = `focusin${Xe}`,
    ai = `click${Xe}${Ye}`,
    li = `click.dismiss${Xe}`,
    ci = `keydown.dismiss${Xe}`;
  class hi extends z {
    constructor(t, e) {
      super(t),
        (this._config = this._getConfig(e)),
        (this._isShown = !1),
        (this._backdrop = this._initializeBackDrop()),
        this._addEventListeners();
    }
    static get NAME() {
      return Qe;
    }
    static get Default() {
      return Ze;
    }
    toggle(t) {
      return this._isShown ? this.hide() : this.show(t);
    }
    show(t) {
      if (this._isShown) return;
      if (B.trigger(this._element, ii, { relatedTarget: t }).defaultPrevented)
        return;
      (this._isShown = !0),
        (this._element.style.visibility = "visible"),
        this._backdrop.show(),
        this._config.scroll ||
          (new ye().hide(), this._enforceFocusOnElement(this._element)),
        this._element.removeAttribute("aria-hidden"),
        this._element.setAttribute("aria-modal", !0),
        this._element.setAttribute("role", "dialog"),
        this._element.classList.add(ti);
      this._queueCallback(
        () => {
          B.trigger(this._element, si, { relatedTarget: t });
        },
        this._element,
        !0
      );
    }
    hide() {
      if (!this._isShown) return;
      if (B.trigger(this._element, ni).defaultPrevented) return;
      B.off(document, ri),
        this._element.blur(),
        (this._isShown = !1),
        this._element.classList.remove(ti),
        this._backdrop.hide();
      this._queueCallback(
        () => {
          this._element.setAttribute("aria-hidden", !0),
            this._element.removeAttribute("aria-modal"),
            this._element.removeAttribute("role"),
            (this._element.style.visibility = "hidden"),
            this._config.scroll || new ye().reset(),
            B.trigger(this._element, oi);
        },
        this._element,
        !0
      );
    }
    dispose() {
      this._backdrop.dispose(), super.dispose(), B.off(document, ri);
    }
    _getConfig(t) {
      return (
        (t = {
          ...Ze,
          ...J.getDataAttributes(this._element),
          ...("object" == typeof t ? t : {}),
        }),
        u(Qe, t, Je),
        t
      );
    }
    _initializeBackDrop() {
      return new $e({
        isVisible: this._config.backdrop,
        isAnimated: !0,
        rootElement: this._element.parentNode,
        clickCallback: () => this.hide(),
      });
    }
    _enforceFocusOnElement(t) {
      B.off(document, ri),
        B.on(document, ri, (e) => {
          document === e.target ||
            t === e.target ||
            t.contains(e.target) ||
            t.focus();
        }),
        t.focus();
    }
    _addEventListeners() {
      B.on(this._element, li, '[data-bs-dismiss="offcanvas"]', () =>
        this.hide()
      ),
        B.on(this._element, ci, (t) => {
          this._config.keyboard && "Escape" === t.key && this.hide();
        });
    }
    static jQueryInterface(t) {
      return this.each(function () {
        const e = hi.getOrCreateInstance(this, t);
        if ("string" == typeof t) {
          if (void 0 === e[t] || t.startsWith("_") || "constructor" === t)
            throw new TypeError(`No method named "${t}"`);
          e[t](this);
        }
      });
    }
  }
  B.on(document, ai, '[data-bs-toggle="offcanvas"]', function (t) {
    const e = l(this);
    if ((["A", "AREA"].includes(this.tagName) && t.preventDefault(), f(this)))
      return;
    B.one(e, oi, () => {
      g(this) && this.focus();
    });
    const i = s.findOne(ei);
    i && i !== e && hi.getInstance(i).hide();
    hi.getOrCreateInstance(e).toggle(this);
  }),
    B.on(window, Ge, () =>
      s.find(ei).forEach((t) => hi.getOrCreateInstance(t).show())
    ),
    E(hi);
  const di = new Set([
      "background",
      "cite",
      "href",
      "itemtype",
      "longdesc",
      "poster",
      "src",
      "xlink:href",
    ]),
    ui = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&/:?]*(?:[#/?]|$))/i,
    gi =
      /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i,
    fi = (t, e) => {
      const i = t.nodeName.toLowerCase();
      if (e.includes(i))
        return (
          !di.has(i) || Boolean(ui.test(t.nodeValue) || gi.test(t.nodeValue))
        );
      const s = e.filter((t) => t instanceof RegExp);
      for (let t = 0, e = s.length; t < e; t++) if (s[t].test(i)) return !0;
      return !1;
    },
    mi = {
      "*": ["class", "dir", "id", "lang", "role", /^aria-[\w-]*$/i],
      a: ["target", "href", "title", "rel"],
      area: [],
      b: [],
      br: [],
      col: [],
      code: [],
      div: [],
      em: [],
      hr: [],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      h5: [],
      h6: [],
      i: [],
      img: ["src", "srcset", "alt", "title", "width", "height"],
      li: [],
      ol: [],
      p: [],
      pre: [],
      s: [],
      small: [],
      span: [],
      sub: [],
      sup: [],
      strong: [],
      u: [],
      ul: [],
    };
  function _i(t, e, i) {
    if (!t.length) return t;
    if (i && "function" == typeof i) return i(t);
    const s = new window.DOMParser().parseFromString(t, "text/html"),
      n = Object.keys(e),
      o = [].concat(...s.body.querySelectorAll("*"));
    for (let t = 0, i = o.length; t < i; t++) {
      const i = o[t],
        s = i.nodeName.toLowerCase();
      if (!n.includes(s)) {
        i.remove();
        continue;
      }
      const r = [].concat(...i.attributes),
        a = [].concat(e["*"] || [], e[s] || []);
      r.forEach((t) => {
        fi(t, a) || i.removeAttribute(t.nodeName);
      });
    }
    return s.body.innerHTML;
  }
  const pi = "tooltip",
    bi = ".bs.tooltip",
    vi = "bs-tooltip",
    yi = new RegExp(`(^|\\s)${vi}\\S+`, "g"),
    Ei = new Set(["sanitize", "allowList", "sanitizeFn"]),
    wi = {
      animation: "boolean",
      template: "string",
      title: "(string|element|function)",
      trigger: "string",
      delay: "(number|object)",
      html: "boolean",
      selector: "(string|boolean)",
      placement: "(string|function)",
      offset: "(array|string|function)",
      container: "(string|element|boolean)",
      fallbackPlacements: "array",
      boundary: "(string|element)",
      customClass: "(string|function)",
      sanitize: "boolean",
      sanitizeFn: "(null|function)",
      allowList: "object",
      popperConfig: "(null|object|function)",
    },
    Ti = {
      AUTO: "auto",
      TOP: "top",
      RIGHT: y() ? "left" : "right",
      BOTTOM: "bottom",
      LEFT: y() ? "right" : "left",
    },
    Ai = {
      animation: !0,
      template:
        '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
      trigger: "hover focus",
      title: "",
      delay: 0,
      html: !1,
      selector: !1,
      placement: "top",
      offset: [0, 0],
      container: !1,
      fallbackPlacements: ["top", "right", "bottom", "left"],
      boundary: "clippingParents",
      customClass: "",
      sanitize: !0,
      sanitizeFn: null,
      allowList: mi,
      popperConfig: null,
    },
    Ci = {
      HIDE: `hide${bi}`,
      HIDDEN: `hidden${bi}`,
      SHOW: `show${bi}`,
      SHOWN: `shown${bi}`,
      INSERTED: `inserted${bi}`,
      CLICK: `click${bi}`,
      FOCUSIN: `focusin${bi}`,
      FOCUSOUT: `focusout${bi}`,
      MOUSEENTER: `mouseenter${bi}`,
      MOUSELEAVE: `mouseleave${bi}`,
    },
    $i = "fade",
    Li = "modal",
    ki = "show",
    Oi = "show",
    Di = "out",
    Ii = "hover",
    Ni = "focus";
  class Si extends z {
    constructor(t, e) {
      if (void 0 === i)
        throw new TypeError(
          "Bootstrap's tooltips require Popper (https://popper.js.org)"
        );
      super(t),
        (this._isEnabled = !0),
        (this._timeout = 0),
        (this._hoverState = ""),
        (this._activeTrigger = {}),
        (this._popper = null),
        (this._config = this._getConfig(e)),
        (this.tip = null),
        this._setListeners();
    }
    static get Default() {
      return Ai;
    }
    static get NAME() {
      return pi;
    }
    static get Event() {
      return Ci;
    }
    static get DefaultType() {
      return wi;
    }
    enable() {
      this._isEnabled = !0;
    }
    disable() {
      this._isEnabled = !1;
    }
    toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    }
    toggle(t) {
      if (this._isEnabled)
        if (t) {
          const e = this._initializeOnDelegatedTarget(t);
          (e._activeTrigger.click = !e._activeTrigger.click),
            e._isWithActiveTrigger() ? e._enter(null, e) : e._leave(null, e);
        } else {
          if (this.getTipElement().classList.contains(ki))
            return void this._leave(null, this);
          this._enter(null, this);
        }
    }
    dispose() {
      clearTimeout(this._timeout),
        B.off(
          this._element.closest(`.${Li}`),
          "hide.bs.modal",
          this._hideModalHandler
        ),
        this.tip && this.tip.remove(),
        this._popper && this._popper.destroy(),
        super.dispose();
    }
    show() {
      if ("none" === this._element.style.display)
        throw new Error("Please use show on visible elements");
      if (!this.isWithContent() || !this._isEnabled) return;
      const t = B.trigger(this._element, this.constructor.Event.SHOW),
        e = m(this._element),
        s =
          null === e
            ? this._element.ownerDocument.documentElement.contains(
                this._element
              )
            : e.contains(this._element);
      if (t.defaultPrevented || !s) return;
      const n = this.getTipElement(),
        r = o(this.constructor.NAME);
      n.setAttribute("id", r),
        this._element.setAttribute("aria-describedby", r),
        this.setContent(),
        this._config.animation && n.classList.add($i);
      const a =
          "function" == typeof this._config.placement
            ? this._config.placement.call(this, n, this._element)
            : this._config.placement,
        l = this._getAttachment(a);
      this._addAttachmentClass(l);
      const { container: c } = this._config;
      q.set(n, this.constructor.DATA_KEY, this),
        this._element.ownerDocument.documentElement.contains(this.tip) ||
          (c.appendChild(n),
          B.trigger(this._element, this.constructor.Event.INSERTED)),
        this._popper
          ? this._popper.update()
          : (this._popper = i.createPopper(
              this._element,
              n,
              this._getPopperConfig(l)
            )),
        n.classList.add(ki);
      const h =
        "function" == typeof this._config.customClass
          ? this._config.customClass()
          : this._config.customClass;
      h && n.classList.add(...h.split(" ")),
        "ontouchstart" in document.documentElement &&
          [].concat(...document.body.children).forEach((t) => {
            B.on(t, "mouseover", _);
          });
      const d = this.tip.classList.contains($i);
      this._queueCallback(
        () => {
          const t = this._hoverState;
          (this._hoverState = null),
            B.trigger(this._element, this.constructor.Event.SHOWN),
            t === Di && this._leave(null, this);
        },
        this.tip,
        d
      );
    }
    hide() {
      if (!this._popper) return;
      const t = this.getTipElement();
      if (
        B.trigger(this._element, this.constructor.Event.HIDE).defaultPrevented
      )
        return;
      t.classList.remove(ki),
        "ontouchstart" in document.documentElement &&
          []
            .concat(...document.body.children)
            .forEach((t) => B.off(t, "mouseover", _)),
        (this._activeTrigger.click = !1),
        (this._activeTrigger[Ni] = !1),
        (this._activeTrigger[Ii] = !1);
      const e = this.tip.classList.contains($i);
      this._queueCallback(
        () => {
          this._isWithActiveTrigger() ||
            (this._hoverState !== Oi && t.remove(),
            this._cleanTipClass(),
            this._element.removeAttribute("aria-describedby"),
            B.trigger(this._element, this.constructor.Event.HIDDEN),
            this._popper && (this._popper.destroy(), (this._popper = null)));
        },
        this.tip,
        e
      ),
        (this._hoverState = "");
    }
    update() {
      null !== this._popper && this._popper.update();
    }
    isWithContent() {
      return Boolean(this.getTitle());
    }
    getTipElement() {
      if (this.tip) return this.tip;
      const t = document.createElement("div");
      return (
        (t.innerHTML = this._config.template),
        (this.tip = t.children[0]),
        this.tip
      );
    }
    setContent() {
      const t = this.getTipElement();
      this.setElementContent(s.findOne(".tooltip-inner", t), this.getTitle()),
        t.classList.remove($i, ki);
    }
    setElementContent(t, e) {
      if (null !== t)
        return h(e)
          ? ((e = d(e)),
            void (this._config.html
              ? e.parentNode !== t && ((t.innerHTML = ""), t.appendChild(e))
              : (t.textContent = e.textContent)))
          : void (this._config.html
              ? (this._config.sanitize &&
                  (e = _i(e, this._config.allowList, this._config.sanitizeFn)),
                (t.innerHTML = e))
              : (t.textContent = e));
    }
    getTitle() {
      let t = this._element.getAttribute("data-bs-original-title");
      return (
        t ||
          (t =
            "function" == typeof this._config.title
              ? this._config.title.call(this._element)
              : this._config.title),
        t
      );
    }
    updateAttachment(t) {
      return "right" === t ? "end" : "left" === t ? "start" : t;
    }
    _initializeOnDelegatedTarget(t, e) {
      const i = this.constructor.DATA_KEY;
      return (
        (e = e || q.get(t.delegateTarget, i)) ||
          ((e = new this.constructor(
            t.delegateTarget,
            this._getDelegateConfig()
          )),
          q.set(t.delegateTarget, i, e)),
        e
      );
    }
    _getOffset() {
      const { offset: t } = this._config;
      return "string" == typeof t
        ? t.split(",").map((t) => Number.parseInt(t, 10))
        : "function" == typeof t
        ? (e) => t(e, this._element)
        : t;
    }
    _getPopperConfig(t) {
      const e = {
        placement: t,
        modifiers: [
          {
            name: "flip",
            options: { fallbackPlacements: this._config.fallbackPlacements },
          },
          { name: "offset", options: { offset: this._getOffset() } },
          {
            name: "preventOverflow",
            options: { boundary: this._config.boundary },
          },
          {
            name: "arrow",
            options: { element: `.${this.constructor.NAME}-arrow` },
          },
          {
            name: "onChange",
            enabled: !0,
            phase: "afterWrite",
            fn: (t) => this._handlePopperPlacementChange(t),
          },
        ],
        onFirstUpdate: (t) => {
          t.options.placement !== t.placement &&
            this._handlePopperPlacementChange(t);
        },
      };
      return {
        ...e,
        ...("function" == typeof this._config.popperConfig
          ? this._config.popperConfig(e)
          : this._config.popperConfig),
      };
    }
    _addAttachmentClass(t) {
      this.getTipElement().classList.add(`${vi}-${this.updateAttachment(t)}`);
    }
    _getAttachment(t) {
      return Ti[t.toUpperCase()];
    }
    _setListeners() {
      this._config.trigger.split(" ").forEach((t) => {
        if ("click" === t)
          B.on(
            this._element,
            this.constructor.Event.CLICK,
            this._config.selector,
            (t) => this.toggle(t)
          );
        else if ("manual" !== t) {
          const e =
              t === Ii
                ? this.constructor.Event.MOUSEENTER
                : this.constructor.Event.FOCUSIN,
            i =
              t === Ii
                ? this.constructor.Event.MOUSELEAVE
                : this.constructor.Event.FOCUSOUT;
          B.on(this._element, e, this._config.selector, (t) => this._enter(t)),
            B.on(this._element, i, this._config.selector, (t) =>
              this._leave(t)
            );
        }
      }),
        (this._hideModalHandler = () => {
          this._element && this.hide();
        }),
        B.on(
          this._element.closest(`.${Li}`),
          "hide.bs.modal",
          this._hideModalHandler
        ),
        this._config.selector
          ? (this._config = {
              ...this._config,
              trigger: "manual",
              selector: "",
            })
          : this._fixTitle();
    }
    _fixTitle() {
      const t = this._element.getAttribute("title"),
        e = typeof this._element.getAttribute("data-bs-original-title");
      (t || "string" !== e) &&
        (this._element.setAttribute("data-bs-original-title", t || ""),
        !t ||
          this._element.getAttribute("aria-label") ||
          this._element.textContent ||
          this._element.setAttribute("aria-label", t),
        this._element.setAttribute("title", ""));
    }
    _enter(t, e) {
      (e = this._initializeOnDelegatedTarget(t, e)),
        t && (e._activeTrigger["focusin" === t.type ? Ni : Ii] = !0),
        e.getTipElement().classList.contains(ki) || e._hoverState === Oi
          ? (e._hoverState = Oi)
          : (clearTimeout(e._timeout),
            (e._hoverState = Oi),
            e._config.delay && e._config.delay.show
              ? (e._timeout = setTimeout(() => {
                  e._hoverState === Oi && e.show();
                }, e._config.delay.show))
              : e.show());
    }
    _leave(t, e) {
      (e = this._initializeOnDelegatedTarget(t, e)),
        t &&
          (e._activeTrigger["focusout" === t.type ? Ni : Ii] =
            e._element.contains(t.relatedTarget)),
        e._isWithActiveTrigger() ||
          (clearTimeout(e._timeout),
          (e._hoverState = Di),
          e._config.delay && e._config.delay.hide
            ? (e._timeout = setTimeout(() => {
                e._hoverState === Di && e.hide();
              }, e._config.delay.hide))
            : e.hide());
    }
    _isWithActiveTrigger() {
      for (const t in this._activeTrigger)
        if (this._activeTrigger[t]) return !0;
      return !1;
    }
    _getConfig(t) {
      const e = J.getDataAttributes(this._element);
      return (
        Object.keys(e).forEach((t) => {
          Ei.has(t) && delete e[t];
        }),
        ((t = {
          ...this.constructor.Default,
          ...e,
          ...("object" == typeof t && t ? t : {}),
        }).container = !1 === t.container ? document.body : d(t.container)),
        "number" == typeof t.delay &&
          (t.delay = { show: t.delay, hide: t.delay }),
        "number" == typeof t.title && (t.title = t.title.toString()),
        "number" == typeof t.content && (t.content = t.content.toString()),
        u(pi, t, this.constructor.DefaultType),
        t.sanitize && (t.template = _i(t.template, t.allowList, t.sanitizeFn)),
        t
      );
    }
    _getDelegateConfig() {
      const t = {};
      if (this._config)
        for (const e in this._config)
          this.constructor.Default[e] !== this._config[e] &&
            (t[e] = this._config[e]);
      return t;
    }
    _cleanTipClass() {
      const t = this.getTipElement(),
        e = t.getAttribute("class").match(yi);
      null !== e &&
        e.length > 0 &&
        e.map((t) => t.trim()).forEach((e) => t.classList.remove(e));
    }
    _handlePopperPlacementChange(t) {
      const { state: e } = t;
      e &&
        ((this.tip = e.elements.popper),
        this._cleanTipClass(),
        this._addAttachmentClass(this._getAttachment(e.placement)));
    }
    static jQueryInterface(t) {
      return this.each(function () {
        const e = Si.getOrCreateInstance(this, t);
        if ("string" == typeof t) {
          if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
          e[t]();
        }
      });
    }
  }
  E(Si);
  const xi = ".bs.popover",
    Mi = "bs-popover",
    Pi = new RegExp(`(^|\\s)${Mi}\\S+`, "g"),
    ji = {
      ...Si.Default,
      placement: "right",
      offset: [0, 8],
      trigger: "click",
      content: "",
      template:
        '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    },
    Hi = { ...Si.DefaultType, content: "(string|element|function)" },
    Ri = {
      HIDE: `hide${xi}`,
      HIDDEN: `hidden${xi}`,
      SHOW: `show${xi}`,
      SHOWN: `shown${xi}`,
      INSERTED: `inserted${xi}`,
      CLICK: `click${xi}`,
      FOCUSIN: `focusin${xi}`,
      FOCUSOUT: `focusout${xi}`,
      MOUSEENTER: `mouseenter${xi}`,
      MOUSELEAVE: `mouseleave${xi}`,
    },
    Bi = ".popover-header",
    Wi = ".popover-body";
  class qi extends Si {
    static get Default() {
      return ji;
    }
    static get NAME() {
      return "popover";
    }
    static get Event() {
      return Ri;
    }
    static get DefaultType() {
      return Hi;
    }
    isWithContent() {
      return this.getTitle() || this._getContent();
    }
    getTipElement() {
      return (
        this.tip ||
          ((this.tip = super.getTipElement()),
          this.getTitle() || s.findOne(Bi, this.tip).remove(),
          this._getContent() || s.findOne(Wi, this.tip).remove()),
        this.tip
      );
    }
    setContent() {
      const t = this.getTipElement();
      this.setElementContent(s.findOne(Bi, t), this.getTitle());
      let e = this._getContent();
      "function" == typeof e && (e = e.call(this._element)),
        this.setElementContent(s.findOne(Wi, t), e),
        t.classList.remove("fade", "show");
    }
    _addAttachmentClass(t) {
      this.getTipElement().classList.add(`${Mi}-${this.updateAttachment(t)}`);
    }
    _getContent() {
      return (
        this._element.getAttribute("data-bs-content") || this._config.content
      );
    }
    _cleanTipClass() {
      const t = this.getTipElement(),
        e = t.getAttribute("class").match(Pi);
      null !== e &&
        e.length > 0 &&
        e.map((t) => t.trim()).forEach((e) => t.classList.remove(e));
    }
    static jQueryInterface(t) {
      return this.each(function () {
        const e = qi.getOrCreateInstance(this, t);
        if ("string" == typeof t) {
          if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
          e[t]();
        }
      });
    }
  }
  E(qi);
  const zi = "scrollspy",
    Fi = ".bs.scrollspy",
    Ui = { offset: 10, method: "auto", target: "" },
    Ki = { offset: "number", method: "string", target: "(string|element)" },
    Vi = `activate${Fi}`,
    Qi = `scroll${Fi}`,
    Xi = `load${Fi}.data-api`,
    Yi = "dropdown-item",
    Gi = "active",
    Zi = ".nav-link",
    Ji = ".list-group-item",
    ts = "position";
  class es extends z {
    constructor(t, e) {
      super(t),
        (this._scrollElement =
          "BODY" === this._element.tagName ? window : this._element),
        (this._config = this._getConfig(e)),
        (this._selector = `${this._config.target} ${Zi}, ${this._config.target} ${Ji}, ${this._config.target} .${Yi}`),
        (this._offsets = []),
        (this._targets = []),
        (this._activeTarget = null),
        (this._scrollHeight = 0),
        B.on(this._scrollElement, Qi, () => this._process()),
        this.refresh(),
        this._process();
    }
    static get Default() {
      return Ui;
    }
    static get NAME() {
      return zi;
    }
    refresh() {
      const t =
          this._scrollElement === this._scrollElement.window ? "offset" : ts,
        e = "auto" === this._config.method ? t : this._config.method,
        i = e === ts ? this._getScrollTop() : 0;
      (this._offsets = []),
        (this._targets = []),
        (this._scrollHeight = this._getScrollHeight());
      s.find(this._selector)
        .map((t) => {
          const n = a(t),
            o = n ? s.findOne(n) : null;
          if (o) {
            const t = o.getBoundingClientRect();
            if (t.width || t.height) return [J[e](o).top + i, n];
          }
          return null;
        })
        .filter((t) => t)
        .sort((t, e) => t[0] - e[0])
        .forEach((t) => {
          this._offsets.push(t[0]), this._targets.push(t[1]);
        });
    }
    dispose() {
      B.off(this._scrollElement, Fi), super.dispose();
    }
    _getConfig(t) {
      if (
        "string" !=
          typeof (t = {
            ...Ui,
            ...J.getDataAttributes(this._element),
            ...("object" == typeof t && t ? t : {}),
          }).target &&
        h(t.target)
      ) {
        let { id: e } = t.target;
        e || ((e = o(zi)), (t.target.id = e)), (t.target = `#${e}`);
      }
      return u(zi, t, Ki), t;
    }
    _getScrollTop() {
      return this._scrollElement === window
        ? this._scrollElement.pageYOffset
        : this._scrollElement.scrollTop;
    }
    _getScrollHeight() {
      return (
        this._scrollElement.scrollHeight ||
        Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight
        )
      );
    }
    _getOffsetHeight() {
      return this._scrollElement === window
        ? window.innerHeight
        : this._scrollElement.getBoundingClientRect().height;
    }
    _process() {
      const t = this._getScrollTop() + this._config.offset,
        e = this._getScrollHeight(),
        i = this._config.offset + e - this._getOffsetHeight();
      if ((this._scrollHeight !== e && this.refresh(), t >= i)) {
        const t = this._targets[this._targets.length - 1];
        this._activeTarget !== t && this._activate(t);
      } else {
        if (this._activeTarget && t < this._offsets[0] && this._offsets[0] > 0)
          return (this._activeTarget = null), void this._clear();
        for (let e = this._offsets.length; e--; ) {
          this._activeTarget !== this._targets[e] &&
            t >= this._offsets[e] &&
            (void 0 === this._offsets[e + 1] || t < this._offsets[e + 1]) &&
            this._activate(this._targets[e]);
        }
      }
    }
    _activate(t) {
      (this._activeTarget = t), this._clear();
      const e = this._selector
          .split(",")
          .map((e) => `${e}[data-bs-target="${t}"],${e}[href="${t}"]`),
        i = s.findOne(e.join(","));
      i.classList.contains(Yi)
        ? (s
            .findOne(".dropdown-toggle", i.closest(".dropdown"))
            .classList.add(Gi),
          i.classList.add(Gi))
        : (i.classList.add(Gi),
          s.parents(i, ".nav, .list-group").forEach((t) => {
            s.prev(t, `${Zi}, ${Ji}`).forEach((t) => t.classList.add(Gi)),
              s.prev(t, ".nav-item").forEach((t) => {
                s.children(t, Zi).forEach((t) => t.classList.add(Gi));
              });
          })),
        B.trigger(this._scrollElement, Vi, { relatedTarget: t });
    }
    _clear() {
      s.find(this._selector)
        .filter((t) => t.classList.contains(Gi))
        .forEach((t) => t.classList.remove(Gi));
    }
    static jQueryInterface(t) {
      return this.each(function () {
        const e = es.getOrCreateInstance(this, t);
        if ("string" == typeof t) {
          if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
          e[t]();
        }
      });
    }
  }
  B.on(window, Xi, () => {
    s.find('[data-bs-spy="scroll"]').forEach((t) => new es(t));
  }),
    E(es);
  const is = ".bs.tab",
    ss = `hide${is}`,
    ns = `hidden${is}`,
    os = `show${is}`,
    rs = `shown${is}`,
    as = `click${is}.data-api`,
    ls = "active",
    cs = "fade",
    hs = "show",
    ds = ".active",
    us = ":scope > li > .active";
  class gs extends z {
    static get NAME() {
      return "tab";
    }
    show() {
      if (
        this._element.parentNode &&
        this._element.parentNode.nodeType === Node.ELEMENT_NODE &&
        this._element.classList.contains(ls)
      )
        return;
      let t;
      const e = l(this._element),
        i = this._element.closest(".nav, .list-group");
      if (i) {
        const e = "UL" === i.nodeName || "OL" === i.nodeName ? us : ds;
        (t = s.find(e, i)), (t = t[t.length - 1]);
      }
      const n = t ? B.trigger(t, ss, { relatedTarget: this._element }) : null;
      if (
        B.trigger(this._element, os, { relatedTarget: t }).defaultPrevented ||
        (null !== n && n.defaultPrevented)
      )
        return;
      this._activate(this._element, i);
      const o = () => {
        B.trigger(t, ns, { relatedTarget: this._element }),
          B.trigger(this._element, rs, { relatedTarget: t });
      };
      e ? this._activate(e, e.parentNode, o) : o();
    }
    _activate(t, e, i) {
      const n = (
          !e || ("UL" !== e.nodeName && "OL" !== e.nodeName)
            ? s.children(e, ds)
            : s.find(us, e)
        )[0],
        o = i && n && n.classList.contains(cs),
        r = () => this._transitionComplete(t, n, i);
      n && o ? (n.classList.remove(hs), this._queueCallback(r, t, !0)) : r();
    }
    _transitionComplete(t, e, i) {
      if (e) {
        e.classList.remove(ls);
        const t = s.findOne(":scope > .dropdown-menu .active", e.parentNode);
        t && t.classList.remove(ls),
          "tab" === e.getAttribute("role") &&
            e.setAttribute("aria-selected", !1);
      }
      t.classList.add(ls),
        "tab" === t.getAttribute("role") && t.setAttribute("aria-selected", !0),
        p(t),
        t.classList.contains(cs) && t.classList.add(hs);
      let n = t.parentNode;
      if (
        (n && "LI" === n.nodeName && (n = n.parentNode),
        n && n.classList.contains("dropdown-menu"))
      ) {
        const e = t.closest(".dropdown");
        e && s.find(".dropdown-toggle", e).forEach((t) => t.classList.add(ls)),
          t.setAttribute("aria-expanded", !0);
      }
      i && i();
    }
    static jQueryInterface(t) {
      return this.each(function () {
        const e = gs.getOrCreateInstance(this);
        if ("string" == typeof t) {
          if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
          e[t]();
        }
      });
    }
  }
  B.on(
    document,
    as,
    '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]',
    function (t) {
      if ((["A", "AREA"].includes(this.tagName) && t.preventDefault(), f(this)))
        return;
      gs.getOrCreateInstance(this).show();
    }
  ),
    E(gs);
  const fs = "toast",
    ms = ".bs.toast",
    _s = `click.dismiss${ms}`,
    ps = `mouseover${ms}`,
    bs = `mouseout${ms}`,
    vs = `focusin${ms}`,
    ys = `focusout${ms}`,
    Es = `hide${ms}`,
    ws = `hidden${ms}`,
    Ts = `show${ms}`,
    As = `shown${ms}`,
    Cs = "hide",
    $s = "show",
    Ls = "showing",
    ks = { animation: "boolean", autohide: "boolean", delay: "number" },
    Os = { animation: !0, autohide: !0, delay: 5e3 };
  class Ds extends z {
    constructor(t, e) {
      super(t),
        (this._config = this._getConfig(e)),
        (this._timeout = null),
        (this._hasMouseInteraction = !1),
        (this._hasKeyboardInteraction = !1),
        this._setListeners();
    }
    static get DefaultType() {
      return ks;
    }
    static get Default() {
      return Os;
    }
    static get NAME() {
      return fs;
    }
    show() {
      if (B.trigger(this._element, Ts).defaultPrevented) return;
      this._clearTimeout(),
        this._config.animation && this._element.classList.add("fade");
      this._element.classList.remove(Cs),
        p(this._element),
        this._element.classList.add(Ls),
        this._queueCallback(
          () => {
            this._element.classList.remove(Ls),
              this._element.classList.add($s),
              B.trigger(this._element, As),
              this._maybeScheduleHide();
          },
          this._element,
          this._config.animation
        );
    }
    hide() {
      if (!this._element.classList.contains($s)) return;
      if (B.trigger(this._element, Es).defaultPrevented) return;
      this._element.classList.remove($s),
        this._queueCallback(
          () => {
            this._element.classList.add(Cs), B.trigger(this._element, ws);
          },
          this._element,
          this._config.animation
        );
    }
    dispose() {
      this._clearTimeout(),
        this._element.classList.contains($s) &&
          this._element.classList.remove($s),
        super.dispose();
    }
    _getConfig(t) {
      return (
        (t = {
          ...Os,
          ...J.getDataAttributes(this._element),
          ...("object" == typeof t && t ? t : {}),
        }),
        u(fs, t, this.constructor.DefaultType),
        t
      );
    }
    _maybeScheduleHide() {
      this._config.autohide &&
        (this._hasMouseInteraction ||
          this._hasKeyboardInteraction ||
          (this._timeout = setTimeout(() => {
            this.hide();
          }, this._config.delay)));
    }
    _onInteraction(t, e) {
      switch (t.type) {
        case "mouseover":
        case "mouseout":
          this._hasMouseInteraction = e;
          break;
        case "focusin":
        case "focusout":
          this._hasKeyboardInteraction = e;
      }
      if (e) return void this._clearTimeout();
      const i = t.relatedTarget;
      this._element === i ||
        this._element.contains(i) ||
        this._maybeScheduleHide();
    }
    _setListeners() {
      B.on(this._element, _s, '[data-bs-dismiss="toast"]', () => this.hide()),
        B.on(this._element, ps, (t) => this._onInteraction(t, !0)),
        B.on(this._element, bs, (t) => this._onInteraction(t, !1)),
        B.on(this._element, vs, (t) => this._onInteraction(t, !0)),
        B.on(this._element, ys, (t) => this._onInteraction(t, !1));
    }
    _clearTimeout() {
      clearTimeout(this._timeout), (this._timeout = null);
    }
    static jQueryInterface(t) {
      return this.each(function () {
        const e = Ds.getOrCreateInstance(this, t);
        if ("string" == typeof t) {
          if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
          e[t](this);
        }
      });
    }
  }
  return (
    E(Ds),
    {
      Alert: Q,
      Button: Y,
      Carousel: $t,
      Collapse: zt,
      Dropdown: pe,
      Modal: Ve,
      Offcanvas: hi,
      Popover: qi,
      ScrollSpy: es,
      Tab: gs,
      Toast: Ds,
      Tooltip: Si,
    }
  );
});
